
{{#if isValid}}
<tr data-item-id="{{id}}" class="orderItem">
    <td class="orderItem-checkbox">
        <label class="isVisuallyHidden" for="{{ id }}">{{ name }}</label>
        <input class="js-action--selectEach" name="{{ id }}" type="checkbox"{{#if selected}} checked{{else}}{{/if}}>
    </td>
    {{#if canUploadFiles}}
        <td class="orderItem-files{{#if printFiles}} orderItem-files_hasFiles{{else}} orderItem-files_needFiles{{/if}}">
            {{#if printFiles}}
                <div class="orderItem-files-counter">{{printFiles.length}}</div>
                <button class="orderItem-files-editble js-action--addFiles">Add / Edit<br />File[s]</button>
            {{else}}
                <button class="orderItem-files-editble js-action--addFiles">Add File[s]</button>
            {{/if}}
        </td>
    {{else}}
        {{#if canPreviewArt}}
            <td class="orderItem-files orderItem-files_viewFiles">
                <button class="js-viewItemFiles">View<br />Artwork</button>
            </td>
        {{else}}
            <td class="orderItem-files orderItem-files_noFiles">
                <button disabled="disabled">No Files<br />Needed</button>
            </td>
        {{/if}}
    {{/if}}
    <td class="orderItem-info">
        <h3 class="orderItem-info-name">{{name}}</h3>
        <div class="orderItem-info-product">{{productName}}{{#unless isStock}} | <span class="lbl lbl_tight">{{width}}" x {{height}}" (WxH)</span>{{/unless}}</div>
        {{#if stockVariantDetails}}
            <div class="orderItem-info-product">{{stockVariantDetails}}</div>
        {{/if}}
        {{#if description }}
            <div class="orderItem-info-description">
                {{ description }}
            </div>
        {{/if}}
    </td>
    <td class="orderItem-qty">
        {{#if stockUnitOfMeasure}}
            <div>{{displayQuantity}}</div>
            <div>{{stockUnitOfMeasure}}</div>
        {{else}}
            {{displayQuantity}}
        {{/if}}
    </td>
    <td class="orderItem-unitPrice">
        <div>${{displayUnitPrice}}</div>
    </td>
    <td class="orderItem-price">
    {{#if isPriceDiscounted}}
        <div style="text-decoration: line-through; opacity: 0.5;">${{displayPrice}}</div>
        <div>${{displayTotalPrice}}</div>
    {{else}}
        ${{displayTotalPrice}}
    {{/if}}
    </td>
</tr>
{{else}}
<tr data-item-id="{{id}}" class="orderItem orderItem_isInvalid">
    <td></td>
    <td class="orderItem-files orderItem-files_noFiles">
        <button disabled="disabled">Invalid Item</button>
    </td>
    <td class="orderItem-info">
        {{#if isPOD}}
            {{#if isTemplated}}
                <h3 class="orderItem-info-name">{{productName}}</h3>
            {{else}}
                <h3 class="orderItem-info-name">{{name}}</h3>
                <div class="orderItem-info-product">{{productName}} | <span class="lbl lbl_tight">{{width}}" x {{height}}" (WxH)</span></div>
            {{/if}}
        {{/if}}
        {{#if isStock}}
            <h3 class="orderItem-info-name">{{productName}}</h3>
            {{#if stockVariantDetails}}
                <div class="orderItem-info-product">{{stockVariantDetails}}</div>
            {{/if}}
        {{/if}}

        <div class="orderItem-info-description">
            This item is no longer valid. Request requote to remove item from your qoute.
        </div>
    </td>
    <td class="orderItem-qty">{{displayQuantity}}</td>
    <td class="orderItem-unitPrice">
        <div>${{displayUnitPrice}}</div>
    </td>
    <td class="orderItem-price">
    {{#if isPriceDiscounted}}
        <div style="text-decoration: line-through; opacity: 0.5;">${{displayPrice}}</div>
        <div>${{displayTotalPrice}}</div>
    {{else}}
        ${{displayTotalPrice}}
    {{/if}}
    </td>
</tr>
{{/if}}
